import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { List, Skeleton } from 'antd';

import InfiniteScroll from 'react-infinite-scroll-component';

import { isEmpty } from 'lodash';

import * as actions from '../../store/actions';
import MessageListItem from './message-list-item';

import { AppDispatch, RootState } from '../../../../store';

import './styles.less';

import { FetchMessagesParams, MakeClearData, MessagesCollection, SelectedNewChatItemEvent, SMSe, UnreadCountData } from '../../models';

const MESSAGE_PAGE_COUNT = 10;

type MessageListProps = {
  setNewUnreadCount: React.Dispatch<React.SetStateAction<UnreadCountData | undefined>>;
  selectedNewChatItem: SelectedNewChatItemEvent;
  messageSearchValue: string | undefined;
  pageNumber: number;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
  makeClearData: MakeClearData | undefined;
  setMakeClearData: React.Dispatch<React.SetStateAction<MakeClearData>>;
};

const MessageList = ({
  setNewUnreadCount,
  selectedNewChatItem,
  messageSearchValue,
  pageNumber,
  setPageNumber,
  makeClearData,
  setMakeClearData,
}: MessageListProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const [idForTheScrollBack, setIdForTheScrollBack] = useState<string | undefined>();

  const { messages, messagesLoading, hasUpdateResult, localMessages, selectedChatItem } = useSelector((state: RootState) => state.smses);

  useEffect(() => {
    dispatch(actions.setMessages({} as MessagesCollection));
    setMakeClearData?.({ clear: true });

    if (selectedChatItem && !isEmpty(selectedChatItem?.smsChatId)) {
      fetchMessages({ pageNumber: 1, smsChatId: selectedChatItem.smsChatId });
    }
  }, [selectedNewChatItem]);

  useEffect(() => {
    if (!selectedChatItem) {
      return;
    }

    let newMessageItems = { ...localMessages } as MessagesCollection | null;

    if (pageNumber !== 1 && newMessageItems && newMessageItems.messageList && newMessageItems.messageList.length > 0) {
      const oldMessages = [...newMessageItems.messageList];
      newMessageItems = { ...messages } as MessagesCollection | null;

      if (newMessageItems?.messageList) {
        newMessageItems.messageList = [...newMessageItems.messageList, ...oldMessages];
      } else if (newMessageItems) {
        newMessageItems.messageList = oldMessages;
      }
    } else {
      newMessageItems = { ...messages } as MessagesCollection | null;
    }

    dispatch(actions.setLocalMessages(newMessageItems));

    if (messages && messages.newUnreadCount > -1) {
      setNewUnreadCount({ newUnreadCount: messages.newUnreadCount, phoneNumber: selectedChatItem.phoneNumber });
    }
  }, [messages]);

  useEffect(() => {
    if (idForTheScrollBack) {
      document.getElementById(idForTheScrollBack)?.scrollIntoView({ block: 'center' });

      setIdForTheScrollBack(undefined);
    }
  }, [localMessages]);

  useEffect(() => {
    if (hasUpdateResult && hasUpdateResult.message && selectedChatItem && !isEmpty(selectedChatItem?.smsChatId)) {
      setPageNumber?.(1);
      fetchMessages({ pageNumber: 1, messageSearchValue, smsChatId: selectedChatItem.smsChatId });
    }
  }, [hasUpdateResult]);

  useEffect(() => {
    clearStateData();
  }, [makeClearData]);

  const fetchMessages = ({ pageNumber, messageSearchValue, smsChatId }: FetchMessagesParams) => {
    dispatch(
      actions.getMessages({
        pageNumber: pageNumber,
        pageSize: MESSAGE_PAGE_COUNT,
        messageSearchValue,
        smsChatId: smsChatId,
      }),
    );
  };

  const clearStateData = () => {
    dispatch(actions.setLocalMessages(null));
  };

  const loadMoreData = () => {
    setPageNumber?.(pageNumber + 1);

    if (localMessages && localMessages.messageList && localMessages.messageList.length > 0) {
      setIdForTheScrollBack(localMessages.messageList[0].id);
    }

    if (selectedChatItem && !isEmpty(selectedChatItem?.smsChatId)) {
      fetchMessages({ pageNumber: pageNumber + 1, messageSearchValue, smsChatId: selectedChatItem.smsChatId });
    }
  };

  return (
    <div id="messagesScrollableDiv" className="messages-scrollable-div custom-scrollbar">
      <InfiniteScroll
        className="messages-infinite-scroll"
        dataLength={localMessages && localMessages.messageList && localMessages.messageList.length > -1 ? localMessages.messageList.length : 0}
        next={loadMoreData}
        inverse={true}
        hasMore={(localMessages && localMessages.hasMore) || messagesLoading}
        loader={<Skeleton paragraph={{ rows: 1 }} active />}
        scrollableTarget="messagesScrollableDiv"
      >
        {(localMessages && localMessages.messageList && localMessages.messageList.length > 0) || !messagesLoading ? (
          <List
            itemLayout="horizontal"
            dataSource={localMessages && localMessages.messageList ? localMessages.messageList : []}
            renderItem={(item: SMSe) => (
              <div key={item.id}>
                <MessageListItem item={item} />
              </div>
            )}
            rowKey={(record) => record.id}
          />
        ) : undefined}
      </InfiniteScroll>
    </div>
  );
};

export default MessageList;
